var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-auto",attrs:{"dark":"","outlined":"","tile":"","color":"#2f3136"}},[(!_vm.isConnected&&!_vm.saved)?_c('span',{},[_vm._v("Open from Minecraft to Save")]):_vm._e(),_c('v-btn',{attrs:{"block":"","color":"warning","disabled":!_vm.isConnected},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.saved? "Saved": "Save"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }